import styles from "./RecommendedOutfitsSimilarItems.scss";
import useRecommendations from "../mightLike/useRecommendations";
import { useRuntimeConstants } from "../../context/runtimeConstants/RuntimeConstantsContext";
import PropTypes from "prop-types";
import { RECOMMENDED_OUTFITS_HEADER, PAGE_AREAS } from "../../constants";
import getDefaultCarouselSettings from "../../utils/getDefaultCarouselSettings";
import {
  Carousel,
  CarouselMode,
} from "@asosteam/asos-web-component-library-carousel";
import { useViewport } from "../../context/viewport/ViewportContext";
import { buildProductTileAriaLabel } from "../productTile/buildProductTileAriaLabel";
import ProductTile from "../productTile/ProductTile";
import useDiscountPercentage from "../../hooks/useDiscountPercentage";
import TitleThenPrice from "../productTile/TitleThenPrice";
import { getSeeSimilarCarouselTrackingValues } from "../../analytics/recommendedOutfits/seeSimilarCarousel";
import { useRef } from "react";

//index-1 to match the zero-based index from the first recommended product
//ctaref sets the prop6
//featureref1 sets the eVar60 and eVar61 values for the product
const generatePdpUrlWithCtaRef = (url, index) =>
  url
    ? `${url}#ctaref-styled+for+you+-+similar+items_${
        index - 1
      }&featureref1-styled+for+you+-+similar+items`
    : null;

function getProductTiles({
  mightLikeProducts,
  showDiscountPercentage,
  getTranslation,
}) {
  return mightLikeProducts.map(
    (
      { url, productTitle, priceData, colourWayId, productId, imageUrl },
      index
    ) => (
      <ProductTile
        key={url}
        url={generatePdpUrlWithCtaRef(url, index)}
        title={productTitle}
        colourWayId={colourWayId}
        productId={productId}
        imageUrl={imageUrl}
        index={index}
        pageArea={PAGE_AREAS.RECOMMENDED_OUTFITS_SIMILAR_ITEMS}
        shouldShowTitle={true}
        productTileAriaLabel={buildProductTileAriaLabel({
          getTranslation,
          title: productTitle,
          priceData,
          showDiscountPercentage,
        })}
      >
        <TitleThenPrice priceData={priceData} title={productTitle} />
      </ProductTile>
    )
  );
}

const shouldFireAnalytics = (fireSimilarItemsAnalytics, hasFiredAnalytics) => {
  if (!hasFiredAnalytics.current && fireSimilarItemsAnalytics) {
    getSeeSimilarCarouselTrackingValues();
    hasFiredAnalytics.current = true;
  }
};
export default function RecommendedOutfitsSimilarItems({
  product,
  fireSimilarItemsAnalytics,
}) {
  const { getTranslation } = useRuntimeConstants();
  const { mightLikeProducts, hasFetchedRecs, apiFailed } = useRecommendations({
    productId: product?.id,
    scope: RECOMMENDED_OUTFITS_HEADER,
  });
  const { showDiscountPercentage } = useDiscountPercentage();
  const { viewportCategory } = useViewport();
  const hasFiredAnalytics = useRef(false);

  if (apiFailed || !hasFetchedRecs || !mightLikeProducts?.length) {
    return null;
  }

  shouldFireAnalytics(fireSimilarItemsAnalytics, hasFiredAnalytics);

  return (
    <div className={styles.recommendedOutfitsMightLike}>
      <div className={styles.header}>
        <h2 id="recommendedOutfitsSimilarItemsTitle" className={styles.title}>
          {getTranslation("pdp_carousel_recommendations_title_similar_items")}
        </h2>
      </div>
      <Carousel
        {...getDefaultCarouselSettings({
          getTranslation,
          viewportCategory,
          CarouselMode,
        })}
        ariaDescribedby="recommendedOutfitsSimilarItemsTitle"
      >
        {getProductTiles({
          mightLikeProducts,
          showDiscountPercentage,
          getTranslation,
        })}
      </Carousel>
    </div>
  );
}

RecommendedOutfitsSimilarItems.propTypes = {
  product: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }).isRequired,
  fireSimilarItemsAnalytics: PropTypes.bool.isRequired,
};
